import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { ControllerWrapper } from '@Hooks/index.ts';
import { FieldError } from '@Components/inputs/FieldError';
import { SelectionGroup } from '@Pages/happyFlowPages/eddQuestions/components/SelectionGroup.tsx';
import { EddEmbeddedFields } from '../fields.types';
import { useCountriesBusinessWithLogic } from './useCountriesBusinessWithLogic';

export const CountriesBusinessWith = () => {
  const { t } = useTranslation();
  const { t: tCommon } = useTranslation();
  const {
    formMethods,
    selectedCustomerCountry,
    selectedVendorCountry,
    countryDataList,
    defaultGroupValues,
    handleSubmit,
    isLoading,
  } = useCountriesBusinessWithLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('countriesDoingBusinessWith.title')}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        headingContainerCustomStyle='!mb-[24px]'>
        <div className='flex flex-col gap-[20px]'>
          <ControllerWrapper
            name={EddEmbeddedFields.EDD_EMBEDDED_CUSTOMER_LOCATION}
            control={formMethods?.control}>
            {({ value, onChange, error }) => (
              <div className='flex flex-col items-start w-full'>
                <SelectionGroup
                  selectedCountry={selectedCustomerCountry}
                  countryDataList={countryDataList}
                  groupTitle={t('countriesDoingBusinessWith.groupATitle')}
                  groupValue={value}
                  optionsList={[
                    {
                      groupId: EddEmbeddedFields.EDD_EMBEDDED_CUSTOMER_LOCATION,
                      value: defaultGroupValues.US.value,
                      label: defaultGroupValues.US.title,
                      inputId: 'businessCountryUS_A',
                      checked: value === defaultGroupValues.US.value,
                      isExtendable: false,
                    },
                    {
                      groupId: EddEmbeddedFields.EDD_EMBEDDED_CUSTOMER_LOCATION,
                      value: defaultGroupValues.OTHER.value,
                      label: defaultGroupValues.OTHER.title,
                      inputId: 'businessCountryOTHER_A',
                      checked: value && value !== defaultGroupValues.US.value,
                      isExtendable: true,
                    },
                  ]}
                  onGroupValueChange={(val) => onChange(val)}
                />
                <FieldError
                  error={error}
                  testId={`${EddEmbeddedFields.EDD_EMBEDDED_CUSTOMER_LOCATION}-error`}
                />
              </div>
            )}
          </ControllerWrapper>

          <ControllerWrapper
            name={EddEmbeddedFields.EDD_EMBEDDED_VENDOR_LOCATION}
            control={formMethods?.control}>
            {({ value, onChange, error }) => (
              <div className='flex flex-col items-start w-full'>
                <SelectionGroup
                  selectedCountry={selectedVendorCountry}
                  countryDataList={countryDataList}
                  groupTitle={t('countriesDoingBusinessWith.groupBTitle')}
                  groupValue={value}
                  optionsList={[
                    {
                      groupId: EddEmbeddedFields.EDD_EMBEDDED_VENDOR_LOCATION,
                      value: defaultGroupValues.US.value,
                      label: defaultGroupValues.US.title,
                      inputId: 'businessCountryUS_B',
                      checked: value === defaultGroupValues.US.value,
                      isExtendable: false,
                    },
                    {
                      groupId: EddEmbeddedFields.EDD_EMBEDDED_VENDOR_LOCATION,
                      value: defaultGroupValues.OTHER.value,
                      label: defaultGroupValues.OTHER.title,
                      inputId: 'businessCountryOTHER_B',
                      checked: value && value !== defaultGroupValues.US.value,
                      isExtendable: true,
                    },
                  ]}
                  onGroupValueChange={(val) => onChange(val)}
                />
                <FieldError
                  error={error}
                  testId={`${EddEmbeddedFields.EDD_EMBEDDED_VENDOR_LOCATION}-error`}
                />
              </div>
            )}
          </ControllerWrapper>
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
